import linesData from "../data/linesData";

class LinesGroup {
    constructor() {
        this.lines = linesData;
    }
}

export default LinesGroup;